<template>
    <div class="book-details">
        <studySearch @searchClick='searchClick' @advancedSearch='advancedSearch' :sourceType="'bookDetails'"></studySearch>
        <div class="details-cont">
            <div class="details-catalogue"> 
                <div class="catalogue">目录</div>
                <div class="catalogue-tree">
                    <el-tree
                        :indent="0"
                        class=" tree-list"
                        :data="catalogueTree" 
                        :props="defaultProps"
                        :highlight-current="true" 
                        ref="navTree" 
                        node-key="dataId"
                        :expand-on-click-node="false"
                        @node-click="handleNodeClick"
                    >   
                        <div class="a" slot-scope="{ data }"> 
                            <i v-if="!data.children || data.children.length === 0" class="el-icon-tickets" /> 
                            {{ data.label }}
                        </div>
                    </el-tree> 
                </div>
            </div>
            <div class="details-info">
                <p class="tit" v-html="bookInfo.title"></p>
                <div class="info-txt" v-html="bookInfo.content"></div>
            </div>
        </div>
        <deductScore ref="deduct_score" v-if="isShowTip" :show.sync="isShowTip" :sourceType="'book'" @refresh="onDeductRefresh"></deductScore>
    </div>
</template>

<script>
import studySearch from './studyPage/comps/study_search.vue'
import { entryInfo,bookCatalogTree, bookInfo } from '../io/api'
import deductScore from './studyPage/comps/study_deduct_score.vue'
export default {
    components: {
        studySearch,
        deductScore,
    },
    data () {
        return {
            isShowTip:false,
            treeId:this.$route.query.id||'',  
            searchWord:this.$route.query.searchWord||'',
            bookInfo:{},
            catalogueTree:[ ],
			treeType:'',
			catalogueInfo:[],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
        }
    },
    mounted(){
        this.getCatalogTree()
    },
    methods: {
        // getList(){
        //     this.getBookInfo();
        //     this.getCatalogTree();
        // },
        getBookInfo(data){ 
            let params={
                id:this.treeId,
                searchWord:this.searchWord
            }
            entryInfo(params).then(res => {
                let {code,data,msg}=res.data;
                if(code==0){
                    this.bookInfo=data.entryInfo||{};
                }else{
                    this.$message.error(msg||'获取古籍信息失败');
                }
            })
        },
         // 获取古籍目录树
        getCatalogTree(){
            let params={
                dataId:this.treeId,
                type:2,
            }
            bookCatalogTree(params).then(res => {
                let {code,data,msg}=res.data;
                if(code==0){
                    this.bookInfo=data.dataInfo||{};
                    this.catalogueTree=data.catalogList||[];
                }else{
                    this.$message.error(msg||'获取古籍目录树失败');
                }
            })
        },
        searchClick(){
            
        },
        advancedSearch(){
            
        },
        handleNodeClick(data, node, el) {
            // 如果有子集，展开/收起子集
            if (data.children && data.children.length > 0) {
                node.expanded = !node.expanded;
            } else {
                // 没有子集，调用扣除积分逻辑
                this.treeId = data.dataId;
                this.isShowTip=true;
                this.$nextTick(()=>{ 
                    this.$refs.deduct_score.get_studyCheckScoreStatus(data,this.searchWord)
                })
            }
        },
        // 扣除积分成功后刷新页面内容
        onDeductRefresh(){
            this.getBookInfo();
        }
    }
}
</script>

<style lang="less" scoped>
.book-details{
    min-width: 1200px;
    margin: 0 auto;
    .details-cont{
        width: 1200px;
        margin: 40px auto;
        padding:30px;
        box-shadow: 0px 3px 12px 0px #c4bfbc;
        display: flex;
        justify-content: space-between;
        .details-catalogue{
            position: relative;
            width: 240px;
            max-height: 450px;
            .catalogue{
                position: absolute;
                top:0;
                left: 0;
                z-index: 9;
                width: 100%;
                height: 40px;
                background: #386DE8;
                line-height: 40px;
                font-size: 16px;
                font-weight: bold;
                color: #F1F5FE;
                padding-left: 30px;
                box-sizing: border-box;
            }
            .catalogue-tree{
                padding-top:40px;
                max-height: 450px;
                overflow-y: auto;
                border: 1px solid #386DE8;;
            }
            // 树样式
            .tree-list{
                min-height: 66px;
                ::v-deep .el-tree-node{
                    position: relative;
                    // 缩进量 
                    // padding-left: 6px; // 缩进量
                }
                // ::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
                //     background: red
                // }
                ::v-deep .tree-icon{
                    font-size: 16px;
                }
                ::v-deep .el-tree-node__content{
                    height: 30px;
                    padding-left: 4px !important;
                    .is-leaf{
                        width: 4px;
                    } 
                    .el-icon-tickets{
                        // font-size: 14px;
                        width: 16px;
                        margin-left: -4px;
                    }
                }
                ::v-deep .el-tree-node__children{
                    padding-left: 16px; // 缩进量
                }
                // 竖线
                ::v-deep .el-tree-node::before{
                    content:"";
                    height: 100%;
                    width: 1px;
                    position: absolute;
                    left:0;
                    top: -24px;
                    border-width: 1px;
                    border-left: 1px dashed #ccc;
                }
                // 当前层最后⼀个节点的竖线⾼度固定
                ::v-deep .el-tree-node:last-child::before{
                    height: 38px; // 可以⾃⼰调节到合适数值
                }
                // 横线
                ::v-deep .el-tree-node::after{
                    content:"";
                    width: 14px;
                    height: 20px;
                    position: absolute;
                    left:0;
                    top: 14px;
                    border-width: 1px;
                    border-top: 1px dashed #ccc;
                }
                // 去掉最顶层的虚线，放最下⾯样式才不会被上⾯的覆盖了
                & > ::v-deep .el-tree-node::after{
                    border-top: none;
                }
                & > ::v-deep .el-tree-node::before{
                    border-left: none;
                }
                // 展开关闭的icon
                ::v-deep .el-tree-node__expand-icon{
                    font-size: 16px;
                    // 叶⼦节点（⽆⼦节点）
                    ::v-deep &.is-leaf{
                        color: transparent;
                        display: none; // 也可以去掉
                    }
                }
            }
        }
        .details-info{
            width: 880px;
            /* background: #F9F6F2; */ 
            border: 1px solid #386DE8;
            float: left;
            margin-bottom: 30px;
            box-sizing: border-box;
            padding: 10px 20px;
            .tit{
                font-weight: bold;
                margin-bottom: 10px;
                font-size: 24px;
            }
            .info-txt {
                text-indent: 2em;
                font-size: 18px;
                line-height: 32px;
                margin-bottom: 10px;
            }
        }
    }
}
</style>